//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'cake_today',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};